"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1DataMock = exports.AFTO781V1DataCertificationMock = exports.AFTO781V1DataARMSAuditMock = exports.AFTO781V1DataARMSInputMock = void 0;
const uuid_1 = require("uuid");
const afto_781_v1_data_model_1 = require("./afto_781_v1-data.model");
const afto_781_v1_aircrew_data_1 = require("./afto_781_v1-aircrew-data");
const afto_781_v1_mission_data_1 = require("./afto_781_v1-mission-data");
class AFTO781V1DataARMSInputMock extends afto_781_v1_data_model_1.AFTO781V1DataARMSInput {
    constructor(data) {
        const seedData = {
            date: Date.now(),
            initials: 'JDS',
        };
        super(seedData);
    }
}
exports.AFTO781V1DataARMSInputMock = AFTO781V1DataARMSInputMock;
class AFTO781V1DataARMSAuditMock extends afto_781_v1_data_model_1.AFTO781V1DataARMSAudit {
    constructor(data) {
        const seedData = {
            date: Date.now(),
            initials: 'RMT',
        };
        super(seedData);
    }
}
exports.AFTO781V1DataARMSAuditMock = AFTO781V1DataARMSAuditMock;
class AFTO781V1DataCertificationMock extends afto_781_v1_data_model_1.AFTO781V1DataCertification {
    constructor(data) {
        const seedData = {
            printedName: 'JOHN D. SMITH',
            rank: 'CAPT',
            branchOfService: 'USAF',
            dsn: '555-1234',
            signature: 'J.D. Smith',
        };
        super(seedData);
    }
}
exports.AFTO781V1DataCertificationMock = AFTO781V1DataCertificationMock;
class AFTO781V1DataMock extends afto_781_v1_data_model_1.AFTO781V1Data {
    constructor(data) {
        const seedData = {
            aircraftId: (0, uuid_1.v4)(),
            missionData: [new afto_781_v1_mission_data_1.AFTO781V1MissionDataMock()],
            flightAuth: '2024-MC-435',
            issuingUnit: '1st Special Operations Wing',
            aircrewData: [new afto_781_v1_aircrew_data_1.AFTO781V1AircrewDataMock()],
            maintReview: 'COMPLETED - NO DISCREPANCIES NOTED',
            pilotReview: ['REVIEWED - J.D.S. CAPT'],
            sarmReview: 'VERIFIED - R.M. THOMPSON TSGT',
            armsInput: new AFTO781V1DataARMSInputMock(),
            armsAudit: new AFTO781V1DataARMSAuditMock(),
            certification: new AFTO781V1DataCertificationMock(),
            remarks: 'Post-flight inspection completed IAW T.O. 1C-130J-6. All systems operating within normal parameters. Minor oil seepage noted on #2 engine, within limits. Weather radar calibration due in 5 flight hours.',
        };
        super(seedData);
    }
}
exports.AFTO781V1DataMock = AFTO781V1DataMock;
